<div class="row">
  <div class="col-md-12 functionaries">
    <ng-container *ngFor="let groupWithFunctionaries of sortedFunctionaries">
      <div class="seperator-headline">
        <div class="seperator-headline__line"></div>
        <h5>{{groupWithFunctionaries.group || 'Sonstige Funktionäre'}}</h5>
      </div>

      <div class="functionaries-wrapper card-shadow">
        <div class="functionary" *ngFor="let functionary of groupWithFunctionaries.functionaries">
          <div class="functionary-inner">
            <app-functionary-card [person]="functionary" [styleMode]="'list-item'"></app-functionary-card>
          </div>
        </div>
      </div>
    </ng-container>

    <p *ngIf="sortedFunctionaries.length === 0">Keine Infos verfügbar</p>
  </div>
</div>
